import React from "react";

function PrivacyPolicy() {
  return (
    <section className="hero">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p><strong>Crypto Trail Officer (CTO AI)</strong><br />Last updated: 12.06.2025</p>
        <p>This Privacy Policy explains how <strong>Crypto Trail Officer (CTO AI)</strong> (&quot;the App&quot;) collects, uses, and protects your personal information.</p>
        <p><strong>1. Data Collected</strong></p>
        <p>The app may collect the following types of data:</p>
        <ul>
          <li><strong>Personal Information:</strong> Email address, username (if signing in with Google/Apple).  </li>
          <li><strong>Device Information:</strong> Device model, OS version, language, region settings.  </li>
          <li><strong>Usage Data:</strong> Navigation behavior, click history, analysis interactions.  </li>
          <li><strong>Ad Data:</strong> Anonymous data via AdMob for personalized ads.  </li>
          <li><strong>Notification Permission:</strong> Whether the user allows push notifications.</li>
        </ul>
        <p><strong>2. Purpose of Data Collection</strong></p>
        <p>Collected data is used to:</p>
        <ul>
          <li>Personalize user experience  </li>
          <li>Provide AI-based analysis results  </li>
          <li>Offer technical support  </li>
          <li>Manage subscriptions/memberships  </li>
          <li>Comply with legal obligations  </li>
          <li>Display and optimize ads (in free version)</li>
        </ul>
        <p><strong>3. Data Sharing</strong></p>
        <p>Data is <strong>not shared</strong> with third parties unless:</p>
        <ul>
          <li>Required by law  </li>
          <li>Shared with services like Google AdMob  </li>
          <li>Used for authentication (Google/Apple Sign-In)  </li>
          <li>Used anonymously for analytics</li>
        </ul>
        <p><strong>4. SDK and Cookie Usage</strong></p>
        <ul>
          <li>No browser cookies are used.  </li>
          <li>Third-party SDKs (AdMob, Firebase, Google Sign-In, Apple Sign-In) are used to deliver services, which may collect data as per their policies.</li>
        </ul>
        <p><strong>5. Data Security</strong></p>
        <p>All data is securely stored via Firebase infrastructure. The app uses TLS/SSL encryption for data transmission.</p>
        <p><strong>6. User Rights</strong></p>
        <p>Users have the right to:</p>
        <ul>
          <li>Access their data  </li>
          <li>Request correction or deletion  </li>
          <li>Opt out of push notifications</li>
        </ul>
        <p>To exercise these rights, please contact us at <a href="mailto:info@cryptotrailofficer.ai">info@cryptotrailofficer.ai</a></p>
        <p><strong>7. Children’s Privacy</strong></p>
        <p>The App is not directed to children under 13 years of age. We do not knowingly collect personal data from children.</p>
        <p><strong>8. Contact</strong></p>
        <p>If you have any questions about this policy:<br />📧 <a href="mailto:info@cryptotrailofficer.ai">info@cryptotrailofficer.ai</a></p>

      </div>
    </section>
  );
}

export default PrivacyPolicy;
